import { render } from "./DisasterRecoveryClusterDisable.vue?vue&type=template&id=f41c8662&scoped=true"
import script from "./DisasterRecoveryClusterDisable.vue?vue&type=script&lang=js"
export * from "./DisasterRecoveryClusterDisable.vue?vue&type=script&lang=js"

import "./DisasterRecoveryClusterDisable.vue?vue&type=style&index=0&id=f41c8662&scoped=true&lang=scss"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41c8662"]])

export default __exports__